export default "__VITE_ASSET__BYmV1LfH__"